import { render, staticRenderFns } from "./InvoiceContactDetails.vue?vue&type=template&id=1601dedd&"
import script from "./InvoiceContactDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceContactDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports